import { render, staticRenderFns } from "./ViqBoardReport.vue?vue&type=template&id=137df8e8&scoped=true"
import script from "./ViqBoardReport.vue?vue&type=script&lang=js"
export * from "./ViqBoardReport.vue?vue&type=script&lang=js"
import style0 from "./ViqBoardReport.vue?vue&type=style&index=0&id=137df8e8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137df8e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137df8e8')) {
      api.createRecord('137df8e8', component.options)
    } else {
      api.reload('137df8e8', component.options)
    }
    module.hot.accept("./ViqBoardReport.vue?vue&type=template&id=137df8e8&scoped=true", function () {
      api.rerender('137df8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqBoardReport.vue"
export default component.exports